import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ShieldCheck, ShieldX } from "lucide-react";
import api from "../lib/api";

export default function VerifyCertificate() {
  const { certId } = useParams();
  const { t } = useTranslation();
  const [cert, setCert] = useState(null);
  const [state, setState] = useState("loading");

  useEffect(() => {
    api.get(`/certificates/verify/${certId}`)
      .then(({ data }) => { setCert(data); setState("valid"); })
      .catch(() => setState("invalid"));
  }, [certId]);

  return (
    <main className="min-h-[70vh] flex items-center justify-center px-6 relative z-10" data-testid="verify-page">
      <div className="w-full max-w-md bg-card border border-primary/15 rounded-lg p-10 text-center">
        <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground">{t("verify.title")}</p>
        {state === "loading" && <p className="mt-8 text-muted-foreground">{t("common.loading")}</p>}
        {state === "valid" && cert && (
          <div data-testid="cert-valid">
            <ShieldCheck size={44} strokeWidth={1.2} className="text-primary mx-auto mt-8" />
            <h1 className="font-serif-display text-3xl mt-5 text-primary">{t("verify.valid")}</h1>
            <div className="gold-line my-6" />
            <p className="text-sm text-muted-foreground">{t("verify.issuedTo")}</p>
            <p className="font-serif-display text-2xl mt-1" data-testid="cert-holder-name">{cert.user_name}</p>
            <p className="text-sm text-foreground/70 mt-3">{cert.level_name}</p>
            <p className="text-xs text-muted-foreground mt-2">{t("verify.issuedOn")} {cert.issued_at?.slice(0, 10)}</p>
            <p className="text-[10px] font-mono text-muted-foreground mt-5">{cert.cert_id}</p>
          </div>
        )}
        {state === "invalid" && (
          <div data-testid="cert-invalid">
            <ShieldX size={44} strokeWidth={1.2} className="text-destructive mx-auto mt-8" />
            <h1 className="font-serif-display text-2xl mt-5">{t("verify.invalid")}</h1>
          </div>
        )}
      </div>
    </main>
  );
}
